// extracted by mini-css-extract-plugin
module.exports = {"switchListBtn":"_1upoqFRm","searchArea":"_2Hgp658K","mapSearchBar":"_3woVei_d","splitter":"_23xAg1Fx","dateSearchBar":"_1z3ceGK9"};